import { PersonalDataSettingsType } from "./personalDataSettingsType";

export const PERSONAL_DATA_SETTINGS: PersonalDataSettingsType = {
	showStateField: true,
	showBirthNameField: true,
	showBirthPlaceField: true,
	fetchLookups: true,
	fetchAnnualIncomeLookups: false,
	showAnnualIncomeField: false,
	showDocumentExpirationField: true,
	showNationalityField: true,
	showOtherSection: true,
	showLugasId: true,
};
